import {
  Slider as ChakraSlider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  SliderProps,
  SliderThumbProps,
  SliderInnerTrackProps
} from "@chakra-ui/react";

type Props = {
  value?: SliderProps["value"];
  min: SliderProps["min"];
  max: SliderProps["max"];
  step: SliderProps["step"];
  onChange?: SliderProps["onChange"];
  onChangeEnd?: SliderProps["onChangeEnd"];
  onChangeStart?: SliderProps["onChangeStart"];
  props?: SliderProps;
  thumbChild?: any;
  thumbProps?: SliderThumbProps;
  filledTrackProps?: SliderInnerTrackProps;
};

export default function Slider({
  min,
  max,
  step,
  onChange,
  onChangeEnd,
  onChangeStart,
  props,
  thumbChild,
  value,
  thumbProps,
  filledTrackProps
}: Props) {
  return (
    <ChakraSlider
      value={value}
      min={min}
      max={max}
      step={step}
      onChange={onChange}
      onChangeEnd={onChangeEnd}
      onChangeStart={onChangeStart}
      {...props}
    >
      <SliderTrack>
        <SliderFilledTrack {...filledTrackProps} />
      </SliderTrack>
      <SliderThumb {...thumbProps}>{thumbChild}</SliderThumb>
    </ChakraSlider>
  );
}
